// extracted by mini-css-extract-plugin
module.exports = {"cell":"_3CRlR","editor-wrapper":"_2EcXP","editorWrapper":"_2EcXP","overlay":"_3e1XZ"};